
export default {
  name: 'ListActions',
  props: {
    viewDetail: {
      type: Boolean,
      default: () => false
    },
    viewDetailTitle: {
      type: String,
      default: 'Lihat'
    },
    editFuelPrice: {
      type: Boolean,
      default: () => false
    },
    editFuelPriceTitle: {
      type: String,
      default: 'Edit Harga BBM'
    },
  }
}
